import React from "react";

import "../../../Header/styles.css"
import canalDenuncia from "../../../../assets/img/canal-denuncia.png";
import atualizeDados from "../../../../assets/img/atualize-dados.png";
import Prevcast from "../../../../assets/img/Prevcast.png";
import instagram from '../../../../assets/img/icon-instagram.png';
import facebook from '../../../../assets/img/icon-facebook.png';
import youtube from '../../../../assets/img/icon-youtube.svg';
import telegram from '../../../../assets/img/icon-telegram.png';
import soudcloud from '../../../../assets/img/icon-soundcloud.png';
import linkedin from '../../../../assets/img/icon-linkedin.png';
const Home = () => {


    return (

        <div >
            <section className="texto-image-direita position-relative" style={{
                backgroundImage: `url(${canalDenuncia})`,
            }}>

                <div className='container h-100'>
                    <div className='row align-items-center h-100'>
                        <div className='col-10 col-md-6 offset-lg-6'>
                            <div className="texto text-white">
                                <h2 className="text-white">
                                    Canal de denúncia
                                </h2>
                                <p>
                                    Nosso canal é um meio seguro para você relatar situações contrárias ao Código de Conduta e Ética da Forluz.
                                </p>

                                <a href="../Governanca/canal-de-denuncia" className="btn btn-primary rounded px-7"> Registrar ocorrência </a>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section className="texto-image-esquerda position-relative" style={{
                backgroundImage: `url(${atualizeDados})`,
            }} >

                <div className='container h-100'>
                    <div className='row align-items-center h-100'>
                        <div className='col-10 col-md-6'>
                            <div className="texto text-white">
                                <h2 className="text-white">
                                    Atualize seus dados
                                </h2>
                                <p>
                                    Se você é participante assistido ou pensionista, não perca tempo. É fácil e muito importante para você!
                                </p>

                                <a href="https://participante.forluz.org.br/" className="btn btn-primary rounded px-7"> Atualizar agora </a>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section className="midias-home">
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col col-md-6'>
                            <div className="midias-home__prevcast pt-10 pb-6 pt-md-0 pb-md-0">
                                <a href="https://soundcloud.com/forluz">
                                    <div className="d-md-flex align-items-start text-white">
                                        <img src={Prevcast} alt="logo" />
                                        <div className="desc ml-md-4 mt-3 mt-md-0">
                                            <h3 className="d-none d-lg-block"> Prevcast </h3>
                                            <p>
                                                Clique aqui e escute nossas pílulas de previdência para conhecer mais sobre os planos.
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className='col col-md-5'>
                            <div className="midias-home__redes text-white text pl-md-5 pl-lg-10 pb-10 pt-8 pt-md-0 pb-md-0">
                                <p> Siga e acompanhe as nossas <br /> redes sociais. </p>
                                <ul className="list-unstyled align-items-center d-flex justify-content-between">
                                    <li className="mr-md-2 mr-xl-0">
                                        <a rel="noreferrer" href="https://www.instagram.com/forluz_oficial/" target="_blank"><img src={instagram} alt="Icone" /></a>
                                    </li>
                                    <li className="mr-md-2 mr-xl-0">
                                        <a rel="noreferrer" href="https://www.facebook.com/forluz.org/" target="_blank"><img src={facebook} alt="Icone" /></a>
                                    </li>
                                    <li className="mr-md-2 mr-xl-0">
                                        <a rel="noreferrer" href="https://www.youtube.com/user/comunicacaoforluz" target="_blank"><img src={youtube} alt="Icone" /></a>
                                    </li>
                                    <li className="mr-md-2 mr-xl-0">
                                        <a rel="noreferrer" href="https://t.me/+rVpfSec-JERhOTIx" target="_blank"><img src={telegram} alt="Icone" /></a>
                                    </li>
                                    <li className="mr-md-2 mr-xl-0">
                                        <a rel="noreferrer" href="https://soundcloud.com/forluz" target="_blank"><img src={soudcloud} alt="Icone" /></a>
                                    </li>
                                    <li className="mr-md-2 mr-xl-0">
                                        <a rel="noreferrer" href="https://www.linkedin.com/company/forluz/" target="_blank"><img src={linkedin} alt="Icone" /></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
};
export default Home;

